<script setup lang="ts">
	import { ref } from "vue"
	import { AppleAuth } from "@/plugins/AppleAuth"

	const loading = ref(false)
	const emit = defineEmits(["success", "error"])

	async function signIn() {
		try {
			loading.value = true
			const result = await AppleAuth.signIn()
			emit("success", result)
		} catch (e) {
			emit("error", { message: e.message })
		} finally {
			loading.value = false
		}
	}
</script>

<template>
	<button class="apple-btn" :disabled="loading" @click="signIn">
		<i class="bi bi-apple apple-icon" aria-hidden="true" />
		<span v-if="!loading">Continue with Apple</span>
		<span v-else class="spinner-border spinner-border-sm" />
	</button>
</template>

<style scoped>
	.apple-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		padding: 0 16px;
		min-width: 220px;
		height: 44px;
		background: #111111;
		border: 1px solid #111111;
		color: #ffffff;
		border-radius: 999px;
		font: 600 14px/20px system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
		cursor: pointer;
		transition: transform 0.15s ease, opacity 0.15s ease;
	}

	.apple-btn:hover:not(:disabled) {
		transform: translateY(-1px);
	}

	.apple-btn:disabled {
		opacity: 0.7;
		cursor: not-allowed;
	}

	.apple-icon {
		font-size: 18px;
	}
</style>
